import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { FormField, LabelPlacement } from '../form-field/form-field';
import { IconRadioDot } from '../icons';

export type RadioButtonProps = {
  invalid?: boolean;
  label?: React.ReactNode;
  labelPlacement?: LabelPlacement;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const RadioButton = forwardRef(
  (
    { invalid, label, labelPlacement = 'right', className, ...radioButtonProps }: RadioButtonProps,
    ref: React.Ref<HTMLInputElement>
  ) => {
    const classNames = classnames(className, 'airtame-radio-button');

    return (
      <FormField
        label={label}
        invalid={invalid}
        labelPlacement={labelPlacement}
        disabled={radioButtonProps.disabled}
        className={classNames}
      >
        <input
          className="airtame-radio-button__replaced"
          ref={ref}
          type="radio"
          {...radioButtonProps}
        />
        <div className="airtame-radio-button__input">
          <IconRadioDot className="airtame-radio-button__mark" />
        </div>
      </FormField>
    );
  }
);

RadioButton.displayName = 'RadioButton';
